import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GuestRoutingModule } from './guest-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SportListComponent } from './sport-list/sport-list.component';
import { CasinoComponent } from './dashboard/casino/casino.component';
import { ICasinoComponent } from './dashboard/i-casino/i-casino.component';
import { InPlayComponent } from './in-play/in-play.component';
import { SharedModule } from '../@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RaceListComponent } from './race-list/race-list.component';


@NgModule({
  declarations: [
    DashboardComponent,
    SportListComponent,
    CasinoComponent,
    ICasinoComponent,
    InPlayComponent,
    RaceListComponent
  ],
  imports: [
    CommonModule,
    GuestRoutingModule,
    FormsModule,
    SharedModule
  ],
})
export class GuestModule { }
